export default "__VITE_ASSET__SYxFEo3N__"